import type { Mode } from "../../../components/general/types/Modify";
import { api } from "../../../services/jobpermissions.service";
import { useJobPermission } from "./useJobPermission";

const permission = "EditSiteAndContact";

export const useCanEditSitesAndContacts = (mode: Mode, fetch: boolean) =>
  useJobPermission(mode, fetch, api.editSitesAndContacts, permission);
